import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';
import {
    getRouteGlobalCatalogItem,
    getRouteOrderCatalogCategoriesItem,
    getRouteOrderMarketplaceItem,
    getRoutePropertiesCatalogInventoryCategoriesItem,
    getRoutePropertiesCatalogItem,
} from 'shared/const/router';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';

export interface UseExpandDetailedViewParams {
    id: string;
    isSearch?: boolean;
    isMoveToCatalogMode: boolean;
    isMoveToInventoryMode?: boolean;
    isGlobalCatalog: boolean | undefined;
    isOrderMarketplace: boolean | undefined;
    selectedPropertyId: string | undefined;
    selectedCategoryId: string | undefined;
    selectedOrderId: string | undefined;
    selectedPropertyCatalogId: string | undefined;
}

export const useExpandDetailedView = ({
    id,
    isSearch,
    isMoveToCatalogMode,
    isMoveToInventoryMode,
    isGlobalCatalog,
    isOrderMarketplace,
    selectedPropertyId,
    selectedCategoryId,
    selectedOrderId,
    selectedPropertyCatalogId,
}: UseExpandDetailedViewParams) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return useCallback(() => {
        dispatch(catalogItemActions.setSelectedItemById(id));
        dispatch(catalogItemActions.setShowDetailedView(true));

        if (isSearch) {
            return;
        }

        if (isMoveToInventoryMode) {
            navigate(
                getRoutePropertiesCatalogInventoryCategoriesItem(
                    selectedPropertyId,
                    selectedCategoryId,
                    id,
                ),
            );
        } else if (isMoveToCatalogMode) {
            if (isGlobalCatalog) {
                navigate(
                    getRouteGlobalCatalogItem(
                        selectedPropertyId,
                        selectedCategoryId,
                        id,
                    ),
                );
            } else {
                navigate(
                    getRoutePropertiesCatalogItem(
                        selectedPropertyId,
                        selectedCategoryId,
                        id,
                    ),
                );
            }
        } else if (isOrderMarketplace) {
            if (!selectedCategoryId) {
                return;
            }
            navigate(getRouteOrderMarketplaceItem(selectedCategoryId, id), {
                state: {
                    selectedOrderId,
                    selectedPropertyCatalogId,
                    selectedPropertyId,
                    fromOrder: selectedOrderId,
                },
            });
        } else {
            navigate(getRouteOrderCatalogCategoriesItem(id), {
                state: {
                    selectedOrderId,
                    selectedPropertyCatalogId,
                    selectedPropertyId,
                    fromOrder: selectedOrderId,
                },
            });
        }
    }, [
        dispatch,
        id,
        isSearch,
        isMoveToInventoryMode,
        isMoveToCatalogMode,
        isGlobalCatalog,
        isOrderMarketplace,
        navigate,
        selectedCategoryId,
        selectedOrderId,
        selectedPropertyCatalogId,
        selectedPropertyId,
    ]);
};
